import axios from 'axios';
import { createApiUrl } from '../../util';
import { PARENT_EVENTS } from '../../constants/index';
import { API_ERROR_CODES } from '../../constants/index';
import api from 'api/axiosInstance';

async function verifyPublicKey(publicKey: string) {
	const { data } = await api.get(createApiUrl(`/organization/verify/${publicKey}`));
	return data;
}

async function getLatLng(address:string, publicKey: string) {
	const config = {
		headers: {
			'Authorization': `Bearer ${publicKey}`
		}
	};
	const { data } = await api.get(createApiUrl(`/designs/getAddress/${address}`), config);
	return data;
}

async function verifyPanelKey(panelKey: string,publicKey: string) {
	// in this case because our backend will use dfault panel keys then
	const config = {
		headers: {
			'Authorization': `Bearer ${publicKey}`
		}
	};
	const { data } = await api.get(createApiUrl(`/panel-type/exists/${encodeURIComponent(panelKey)}`), config);
	return data;
}

async function getDesignByExternalID(externalID: string, publicKey: string) {
	const config = {
		headers: {
			'Authorization': `Bearer ${publicKey}`
		}
	};
	const { data } = await api.get(createApiUrl(`/designs/designByExternalID/${externalID}`), config);
	return data;
}

async function getDesignMetdaDataByExternalId(externalID: string, publicKey: string) {
	const config = {
		headers: {
			'Authorization': `Bearer ${publicKey}`
		}
	};
	// change it to uuid if it exists
	try {
		const { data } = await api.get(createApiUrl(`/designs/get-design-meta-data/${externalID}`), config);
		return data;
	}
	catch (error: any) {
		if (error.response && error.response.status === 400 
			&& error.response.data.errorCode === API_ERROR_CODES.DESIGN_DELETED) {
			window.parent.postMessage({ 
				id: PARENT_EVENTS.DESIGN_HAS_RESET, 
				detail: error.response.data,
			}, '*');
		}
		return error.response.data;
	}
}

async function getDesignMetaDataByUUID(uuid: string, publicKey: string) {
	const config = {
		headers: {
			'Authorization': `Bearer ${publicKey}`
		}
	};
	// change it to uuid if it exists
	try{
		const { data } = await api.get<DesignWithoutRelations>(createApiUrl(`/designs/get-design-meta-data-by-uuid/${uuid}`), config);
		return data;
	}
	catch (error: any) {
		if (error.response && error.response.status === 400 
			&& error.response.data.errorCode === API_ERROR_CODES.DESIGN_DELETED) {
			window.parent.postMessage({ 
				id: PARENT_EVENTS.DESIGN_HAS_RESET, 
				detail: error.response.data,
			}, '*');
		}
		return error.response.data;
	}
}

async function getThemeData(publicKey: string) {
	const config = {
		headers: {
			'Authorization': `Bearer ${publicKey}`
		}
	};
	// change it to uuid if it exists
	const { data } = await api.get<DesignWithoutRelations>(createApiUrl('/organization'), config);
	return data;
}

export {
	verifyPublicKey,
	verifyPanelKey,
	getLatLng,
	getDesignByExternalID,
	getDesignMetaDataByUUID,
	getDesignMetdaDataByExternalId,
	getThemeData
};